module.exports = __webpack_public_path__ + "img/facebook-icon.7b2e14b1.svg";